// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__QtisM","choiceBoxes":"toolbarselects_choiceBoxes__3MMx7","simpleField":"toolbarselects_simpleField__WgkEs"};